import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { BackButton } from '../../../../general/components/back-button';
import { Loading } from '../../../../general/components/loading';
import { WizardPage } from '../../../../general/components/wizard-page';
import { VERIFY_REVENUE } from '../../../../paths';
import { RootState } from '../../../../store';
import { nextStep } from '../../../application/reducers/next-step';
import { BankConnection } from '../../../bank-account-connection/components/bank-connection';
import { BankAccountVerificationSuccessEvent } from '../../../bank-account-connection/hooks/post-message-listener/PostMessageListener';
import {
  getBankAccountLinkingWidgetUrl,
  notifyBankAccountConnected,
} from '../../reducers/bank-account-linking.reducer';

const selector = ({ bankAccountLinking: { widgetUrl, loading, error } }: RootState) => ({
  widgetUrl,
  loading,
  error,
});

const VerifyRevenueMxPage: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBankAccountLinkingWidgetUrl());
  }, [dispatch]);

  const { widgetUrl, loading, error } = useSelector(selector);

  const navigate = useNavigate();
  const handleBack = useCallback(() => {
    navigate(VERIFY_REVENUE);
  }, [navigate]);

  const handleBankAccountVerificationSuccess = useCallback(
    (event: BankAccountVerificationSuccessEvent) => {
      dispatch(
        notifyBankAccountConnected({
          event,
          onSuccess: nextStep({ gotoNextPage: true }),
        }),
      );
    },
    [dispatch],
  );

  return (
    <WizardPage
      onBack={handleBack}
      title="Link your business bank account"
      subtext="Connecting to your bank can take a few minutes: please don't close the page."
      error={error}
    >
      <Loading open={loading} />
      {widgetUrl && (
        <BankConnection
          title="mx-widget"
          widgetUrl={widgetUrl}
          onBankAccountVerificationSuccess={handleBankAccountVerificationSuccess}
        />
      )}
      <BackButton />
    </WizardPage>
  );
};

export { VerifyRevenueMxPage };
